export default (() => {
    const trackerCookieDomain = "directly.com";
    const trackerId = window.googleAnalyticsTrackingId;
    const userId = window.googleAnalyticsUserId;
    let localTrackerName = "directlyTracker";
    let localEventCategory = "directlyEventCategory";
    let localEventLabel;
    let localGa;

    const load = () => {
        /* eslint-disable */
        ((i, s, o, g, r, a, m) => {
            i["GoogleAnalyticsObject"] = r;
            (i[r] =
                i[r] ||
                function() {
                    (i[r].q = i[r].q || []).push(arguments);
                }),
                (i[r].l = 1 * new Date());
            (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, "script", "https://www.google-analytics.com/analytics.js", "ga");
        /* eslint-enable */
    };

    const init = ({ eventLabel, trackerName, eventCategory }) => {
        if (!window.googleAnalyticsTrackingId) {
            return;
        }
        if (!window.ga) {
            load();
        }

        if (trackerName) {
            localTrackerName = trackerName;
        }

        if (eventCategory) {
            localEventCategory = eventCategory;
        }

        window.ga("create", trackerId, trackerCookieDomain, localTrackerName, userId ? { userId } : {});

        localGa = window.ga;

        if (eventLabel) {
            localEventLabel = eventLabel;
        }
    };

    const pageview = path => {
        if (localGa) {
            localGa(`${localTrackerName}.send`, "pageview", path);
        }
    };

    const event = ({ category, action, label, value }) => {
        if (localGa) {
            localGa(`${localTrackerName}.send`, "event", {
                eventCategory: category,
                eventAction: action,
                eventLabel: label,
                eventValue: value,
            });
        }
    };

    const sendGaEvent = ({ action, value, label }) => {
        const eventValues = {
            category: localEventCategory,
            action,
            value,
        };

        if (localEventLabel) {
            eventValues.label = localEventLabel;
        } else if (label) {
            eventValues.label = label;
        }

        event(eventValues);
    };

    const set = (key, val) => {
        if (localGa) {
            localGa(`${localTrackerName}.set`, key, val);
        }
    };

    const exception = error => {
        if (localGa) {
            set("page", window.location.href);
            localGa(`${localTrackerName}.send`, "exception", {
                exDescription: JSON.stringify(error),
                exFatal: false,
            });
        }
    };

    const timing = ({ category, variable, value, label }) => {
        if (localGa) {
            localGa(`${localTrackerName}.send`, "timing", {
                timingCategory: category,
                timingVar: variable,
                timingValue: value,
                timingLabel: label,
            });
        }
    };

    return {
        init,
        pageview,
        event,
        exception,
        timing,
        set,
        sendGaEvent,
    };
})();
